import type {Schemas} from 'api/dto.generated';
import type {UpdateLog, UpdateLogPage} from '../types';

const mapUpdateLogDto = (dto: Schemas.UpdateLogDto): UpdateLog => ({
  updatedBy: dto.updatedBy,
  ean: dto.ean,
  // Backend serializes `created` as epoch seconds (cf. mapBulkUpdateSummaryDto).
  created: dto.created * 1000,
  statusChanged: dto.statusChanged,
});

export const mapUpdateLogsDto = (
  dto: Schemas.UpdateLogsDto,
): UpdateLogPage => ({
  page: dto.page ?? 0,
  elementCount: dto.elementCount ?? 0,
  pageCount: dto.pageCount ?? 0,
  hasNext: dto.hasNext ?? false,
  items: (dto.items ?? []).map(mapUpdateLogDto),
});
